
import { DeskData } from '@/datamodel/deskdata'
import { ResponseData } from '@/datamodel/response-data'
import { Device } from '@/store/types'
import { Options, Vue } from 'vue-class-component'
import { Action, Getter } from 'vuex-class'
import HeaderView from '@/components/header/index.vue'
import MarqueeText from '@/components/common/marquee-text.vue'
import { Screenfull } from 'screenfull'
import screenfull from 'screenfull'
import { Watch } from 'vue-property-decorator'
import PcSwitchTable from '@/components/desk/switch-table/d-switch-table.vue'
import CustomMoneyView from '@/components/dialogs/custom-money-dialog-view.vue'
import LimitDialogView from '@/components/dialogs/limit-dialog-view.vue'
import SettingView from '@/components/dialogs/setting-dialog-view.vue'
import ChangePasswordView from '@/components/dialogs/change-pass-view.vue'
import BetHistory from '@/components/dialogs/history-view.vue'
import { to24HoursFormat } from '@/utils'
import MultiViewCenterListItem from '@/components/multi-view/center-list-item.vue'
import MultiViewSideListItem from '@/components/multi-view/side-list-item.vue'
import DGoodRoadPanel from '@/components/desk/good-road/d-good-road-panel.vue'
import {
    countGoodRoadTables,
    filterGoodRoadGameTables
} from '@/components/desk/good-road/utils'
import axios, { CancelTokenSource } from 'axios'
import router, { ROUTES } from '@/router'
import {
    AxiosSource,
    getHallData,
    getMultiTableDetail,
    getTableInfo
} from '@/api'
import { store } from '@/store'
import { UserMutation } from '@/store/module/user'
import { MemberLimit, SocketMessage, Table } from 'vue'
import { LobyMutation } from '@/store/module/loby'
import { EventBuss, SOCKET_MESSAGE } from '@/utils/constants'
import { MultiViewMutations } from '@/store/module/mutli-view'
import { DeskMutation } from '@/store/module/desk'
import RuleView from '@/components/dialogs/rule-view.vue'

@Options({
    components: {
        HeaderView,
        'marquee-text': MarqueeText,
        CustomMoneyView,
        PcSwitchTable,
        LimitDialogView,
        SettingView,
        ChangePasswordView,
        BetHistory,
        MultiViewCenterListItem,
        MultiViewSideListItem,
        DGoodRoadPanel,
        RuleView
    }
})
export default class MultiViewLoby extends Vue {
    showLimitDialog = false
    showHistory = false
    showPasswordForm = false
    showSettings = false
    showCustumChip = false
    showSwicthTable = false
    showGoodRoadPanel = false
    goodRoadCount = 0
    goodRoadTablesCache: Table[] = []
    activeDragIndex = -1

    showRule = false

    videoIsLoading = true

    isSuper6Mode = false

    nodePlayer!: any

    videoPlayerCollection: Array<any> = new Array<any>()
    videoPlayerSession = 0

    currentDeskNo = -1

    tables: Table[] = []
    multipleTables: Table[] = []
    currentDesk: Table | undefined

    dateTimeStr = to24HoursFormat(new Date())
    dateTimeInterval: number | boolean = false

    hasPendingRequest = false

    deskTimer: number | boolean = false
    serviceTimeOut: number | boolean = false
    countDownTimer: number | boolean = false
    currentCount = -1

    isNoticeView = true
    noticeIsPaused = false

    videos: string[] = []
    videoRequestFailure = 0
    videoRequestTimeOut: boolean | number | any = false
    videoAxiosSource?: CancelTokenSource

    failureCounter = 0

    PULL_INTERVAL = 3000

    gType = ''

    emitter!: Vue['emitter']

    @Getter('isFullScreen') isFullScreen!: boolean
    @Getter('chips') chips!: Array<number>
    @Getter('customChipValue') customChipValue!: number
    @Getter('currentChipIndex') chipIndex!: number
    @Getter('device') device!: Device
    @Getter('selectedTables') selectedTables!: Array<number>
    @Getter('userId') userId!: string
    @Getter('token') token!: string
    @Getter('memberId') memberId!: number
    @Getter('lobyNotice') lobyNotice!: string
    @Getter('deskInfoKey') deskInfoKey!: number
    @Getter('betCoin') betCoin!: number
    @Getter('limitId') limitId!: number
    @Getter('deskLimit') deskLimit!: MemberLimit

    @Action('showLoading') showLoading!: () => void
    @Action('hideLoading') hideLoading!: () => void
    @Action('destroySession') destroySession!: () => void

    @Action('setFullScreen') setFullScreen!: (isFull: boolean) => void
    @Action('setCurrentChipIndex') setCurrentChipIndex!: (
        indexPosition: number
    ) => void
    @Action('setBetCoin') setBetCoin!: (userPoint: number) => void

    timerTimeOut: number | boolean = false
    timerStarted = false

    //#region Vue Methods
    beforeMount(): void {
        if (this.device.display === 1) {
            router.push({ name: ROUTES.LOBY })
            return
        }

        this.emitter.on(EventBuss.SOCKET_MESSAGE, this.handlesSocketMessages)
        this.emitter.on(EventBuss.BET_SUCCESS, this.handleOnBetSuccess)
        this.emitter.on(EventBuss.PAGE_ON_VISIBLE, this.onPageVisible)
        this.emitter.on(
            EventBuss.SOCKET_RECONNECTED,
            this.handleReconnectSuccess
        )
    }

    mounted(): void {
        // this.currentDeskNo = this.currentDesk?.deskId || 0
        this.dateTimeInterval = setInterval(() => {
            this.dateTimeStr = to24HoursFormat(new Date())
        }, 1000)

        this.loadData()
    }

    doCountDown(): void {
        this.timerTimeOut = setTimeout(() => {
            this.multipleTables.forEach((item, index) => {
                if (item.expand.daoJiShiBetTime >= 0) {
                    this.multipleTables[index].expand.daoJiShiBetTime -= 1
                } else {
                    this.multipleTables[index].expand.daoJiShiBetTime = -1
                    this.multipleTables[index].status = 2
                }

                if (item.id === this.currentDeskNo) {
                    this.currentCount = this.multipleTables[
                        index
                    ].expand.daoJiShiBetTime
                }
            })

            this.tables.forEach((item, index) => {
                if (item.expand.daoJiShiBetTime >= 0) {
                    this.tables[index].expand.daoJiShiBetTime -= 1
                } else {
                    this.tables[index].expand.daoJiShiBetTime = -1
                    this.tables[index].status = 2
                }
            })

            this.doCountDown()
        }, 1000)
    }

    cancelCountDown(): void {
        if (typeof this.timerTimeOut === 'number') {
            clearTimeout(this.timerTimeOut)
            this.timerTimeOut = false
            this.timerStarted = false
        }
    }

    beforeUnmount(): void {
        this.stopCountDown()
        this.endService()
        this.disposeVideoPlayer()
        if (typeof this.dateTimeInterval === 'number') {
            clearInterval(this.dateTimeInterval)
            this.dateTimeInterval = false
        }

        this.cancelCountDown()

        this.emitter.off(EventBuss.SOCKET_MESSAGE, this.handlesSocketMessages)
        this.emitter.off(EventBuss.BET_SUCCESS, this.handleOnBetSuccess)
        this.emitter.off(EventBuss.PAGE_ON_VISIBLE, this.onPageVisible)
        this.emitter.off(
            EventBuss.SOCKET_RECONNECTED,
            this.handleReconnectSuccess
        )
    }

    onPageVisible(): void {
        this.loadData(true)
    }

    handleReconnectSuccess(): void {
        console.log('SOCKET RECONNECTED')
        this.loadData(true)
    }

    handlesSocketMessages(_message: SocketMessage | any) {
        // console.log(_message.type.toUpperCase())
        const { type, gameTable } = _message

        const _type = (type as string).toUpperCase()

        if (_type === SOCKET_MESSAGE.NEW_GAME) {
            const sDesk = gameTable as Table
            let index = this.tables.findIndex(item => item.id === sDesk.id)
            if (index !== -1) {
                const _copy = { ...this.tables[index] }

                _copy.expand.shoeNo = sDesk.expand.shoeNo
                _copy.expand.juNo = sDesk.expand.juNo
                _copy.expand.gameNo = sDesk.expand.gameNo
                _copy.expand.daoJiShiBetTime = sDesk.expand.daoJiShiBetTime

                _copy.expand.betFormList = []
                _copy.expand.xianAmount = 0
                _copy.expand.xianDuiAmount = 0
                _copy.expand.zhuangAmount = 0
                _copy.expand.zhuangDuiAmount = 0
                _copy.expand.heAmount = 0

                _copy.expand.playerOne = undefined
                _copy.expand.playerTwo = undefined
                _copy.expand.playerThree = undefined
                _copy.expand.bankerOne = undefined
                _copy.expand.bankerTwo = undefined
                _copy.expand.bankerThree = undefined
                _copy.expand.playerCount = undefined
                _copy.expand.bankerCount = undefined
                _copy.expand.whoWin = -1
                _copy.timeStamp = new Date().getTime()

                this.tables[index] = _copy
            }

            // update multiList data
            index = this.multipleTables.findIndex(item => item.id === sDesk.id)
            if (index !== -1) {
                const _copy = { ...this.multipleTables[index] }

                _copy.expand.shoeNo = sDesk.expand.shoeNo
                _copy.expand.juNo = sDesk.expand.juNo
                _copy.expand.gameNo = sDesk.expand.gameNo
                _copy.expand.daoJiShiBetTime = sDesk.expand.daoJiShiBetTime

                _copy.expand.betFormList = []
                _copy.expand.xianAmount = 0
                _copy.expand.xianDuiAmount = 0
                _copy.expand.zhuangAmount = 0
                _copy.expand.zhuangDuiAmount = 0
                _copy.expand.heAmount = 0

                _copy.expand.playerOne = undefined
                _copy.expand.playerTwo = undefined
                _copy.expand.playerThree = undefined
                _copy.expand.bankerOne = undefined
                _copy.expand.bankerTwo = undefined
                _copy.expand.bankerThree = undefined
                _copy.expand.playerCount = undefined
                _copy.expand.bankerCount = undefined
                _copy.expand.whoWin = -1
                _copy.timeStamp = new Date().getTime()

                this.multipleTables[index] = _copy
            }
        } else if (_type === SOCKET_MESSAGE.END_GAME) {
            const sDesk = gameTable as Table
            let index = this.tables.findIndex(item => item.id === sDesk.id)
            if (index !== -1) {
                const _copy = { ...this.tables[index] }

                _copy.expand.playerOne = sDesk.expand.playerOne
                _copy.expand.playerTwo = sDesk.expand.playerTwo
                _copy.expand.playerThree = sDesk.expand.playerThree
                _copy.expand.bankerOne = sDesk.expand.bankerOne
                _copy.expand.bankerTwo = sDesk.expand.bankerTwo
                _copy.expand.bankerThree = sDesk.expand.bankerThree
                _copy.expand.playerCount = sDesk.expand.playerCount
                _copy.expand.bankerCount = sDesk.expand.bankerCount
                _copy.expand.whoWin = sDesk.expand.whoWin
                _copy.expand.resultList = sDesk.expand.resultList

                // reset bet data
                _copy.expand.betFormList = []
                _copy.expand.xianAmount = 0
                _copy.expand.xianDuiAmount = 0
                _copy.expand.zhuangAmount = 0
                _copy.expand.zhuangDuiAmount = 0
                _copy.expand.heAmount = 0
                this.tables[index] = _copy
            }

            index = this.multipleTables.findIndex(item => item.id === sDesk.id)
            if (index !== -1) {
                const _copy = { ...this.multipleTables[index] }

                _copy.expand.playerOne = sDesk.expand.playerOne
                _copy.expand.playerTwo = sDesk.expand.playerTwo
                _copy.expand.playerThree = sDesk.expand.playerThree
                _copy.expand.bankerOne = sDesk.expand.bankerOne
                _copy.expand.bankerTwo = sDesk.expand.bankerTwo
                _copy.expand.bankerThree = sDesk.expand.bankerThree
                _copy.expand.playerCount = sDesk.expand.playerCount
                _copy.expand.bankerCount = sDesk.expand.bankerCount
                _copy.expand.whoWin = sDesk.expand.whoWin
                _copy.expand.resultList = sDesk.expand.resultList

                // reset bet data
                _copy.expand.betFormList = []
                _copy.expand.xianAmount = 0
                _copy.expand.xianDuiAmount = 0
                _copy.expand.zhuangAmount = 0
                _copy.expand.zhuangDuiAmount = 0
                _copy.expand.heAmount = 0
                this.multipleTables[index] = _copy
            }
        } else if (_type === SOCKET_MESSAGE.BET) {
            const sDesk = gameTable as Table
            let index = this.tables.findIndex(item => item.id === sDesk.id)
            if (index !== -1) {
                const _copy = { ...this.tables[index] }
                if (sDesk.expand.memberId === this.memberId) {
                    _copy.expand.betFormList = sDesk.expand.betFormList
                    _copy.expand.amount = sDesk.expand.amount
                    this.tables[index] = _copy
                    store.commit(UserMutation.SET_BET_COIN, sDesk.expand.amount)
                }
            }

            index = this.multipleTables.findIndex(item => item.id === sDesk.id)
            if (index !== -1) {
                const _copy = { ...this.multipleTables[index] }
                if (sDesk.expand.memberId === this.memberId) {
                    _copy.expand.betFormList = sDesk.expand.betFormList
                    _copy.expand.amount = sDesk.expand.amount
                    this.multipleTables[index] = _copy
                    store.commit(UserMutation.SET_BET_COIN, sDesk.expand.amount)
                }
            }
        } else if (_type === SOCKET_MESSAGE.STOP_GAME) {
            const sDesk = gameTable as Table
            let index = this.tables.findIndex(item => item.id === sDesk.id)
            if (index !== -1) {
                const _copy = { ...this.tables[index] }
                _copy.expand.daoJiShiBetTime = 0
                _copy.status = 2
                this.tables[index] = _copy
            }

            index = this.multipleTables.findIndex(item => item.id === sDesk.id)
            if (index !== -1) {
                const _copy = { ...this.multipleTables[index] }
                _copy.expand.daoJiShiBetTime = 0
                _copy.status = 2
                this.multipleTables[index] = _copy
            }
        } else if (_type === SOCKET_MESSAGE.CANCEL_GAME) {
            const sDesk = gameTable as Table
            let index = this.tables.findIndex(item => item.id === sDesk.id)
            if (index !== -1) {
                const _copy = { ...this.tables[index] }
                _copy.expand.betFormList = []
                _copy.status = sDesk.status
                this.tables[index] = _copy
            }

            index = this.multipleTables.findIndex(item => item.id === sDesk.id)
            if (index !== -1) {
                const _copy = { ...this.multipleTables[index] }
                _copy.expand.betFormList = []
                _copy.status = sDesk.status
                this.multipleTables[index] = _copy
            }
        } else if (_type === SOCKET_MESSAGE.STOP_BET) {
            const sDesk = gameTable as Table
            const index = this.tables.findIndex(item => item.id === sDesk.id)
            if (index !== -1) {
                const _copy = { ...this.tables[index] }
                _copy.expand.stopBet = 1
                this.tables[index] = _copy

                if (sDesk.expand.amount) {
                    store.commit(UserMutation.SET_BET_COIN, sDesk.expand.amount)
                }
            }
        } else if (_type === SOCKET_MESSAGE.NEW_SHOE) {
            const sDesk = gameTable as Table
            let index = this.tables.findIndex(item => item.id === sDesk.id)
            if (index !== -1) {
                const _copy = { ...this.tables[index] }
                sDesk.expand.betFormList = []

                const {
                    downLimit,
                    upLimit,
                    limitMax,
                    pairDownLimit,
                    pairUpLimit,
                    tieDownLimit,
                    tieUpLimit,
                    superSixDownLimit,
                    superSixUpLimit
                } = _copy
                sDesk.downLimit = downLimit
                sDesk.upLimit = upLimit
                sDesk.limitMax = limitMax
                sDesk.pairDownLimit = pairDownLimit
                sDesk.pairUpLimit = pairUpLimit
                sDesk.tieDownLimit = tieDownLimit
                sDesk.tieUpLimit = tieUpLimit
                sDesk.superSixDownLimit = superSixDownLimit
                sDesk.superSixUpLimit = superSixUpLimit

                this.tables[index] = sDesk
            }

            index = this.multipleTables.findIndex(item => item.id === sDesk.id)
            if (index !== -1) {
                const _copy = { ...this.multipleTables[index] }
                sDesk.expand.betFormList = []

                const {
                    downLimit,
                    upLimit,
                    limitMax,
                    pairDownLimit,
                    pairUpLimit,
                    tieDownLimit,
                    tieUpLimit,
                    superSixDownLimit,
                    superSixUpLimit
                } = _copy
                sDesk.downLimit = downLimit
                sDesk.upLimit = upLimit
                sDesk.limitMax = limitMax
                sDesk.pairDownLimit = pairDownLimit
                sDesk.pairUpLimit = pairUpLimit
                sDesk.tieDownLimit = tieDownLimit
                sDesk.tieUpLimit = tieUpLimit
                sDesk.superSixDownLimit = superSixDownLimit
                sDesk.superSixUpLimit = superSixUpLimit

                this.multipleTables[index] = sDesk
            }
        }

        this.syncGoodRoadCountFromSocket(_type, gameTable as Table)
    }

    //#endregion

    handleOnBetSuccess(obj: {
        betFormList: any[]
        id: number
        amount: number
    }): void {
        if (obj.betFormList && obj.betFormList) {
            let index = this.tables.findIndex(item => item.id === obj.id)
            if (index !== -1) {
                const _copy = { ...this.tables[index] }

                _copy.expand.betFormList = obj.betFormList
                _copy.expand.amount = obj.amount
                this.tables[index] = _copy
                store.commit(UserMutation.SET_BET_COIN, obj.amount)
            }
            index = this.multipleTables.findIndex(item => item.id === obj.id)
            if (index !== -1) {
                const _copy = { ...this.multipleTables[index] }

                _copy.expand.betFormList = obj.betFormList
                _copy.expand.amount = obj.amount
                this.multipleTables[index] = _copy
                store.commit(UserMutation.SET_BET_COIN, obj.amount)
            }
        }
    }

    loadData(_forceReload = false): void {
        if (!_forceReload) this.showLoading()
        let _params = {
            token: this.token,
            gameTypeNo: ''
        }

        getHallData(_params)
            .then(r => {
                this.failureCounter = 0
                if (!_forceReload) this.hideLoading()
                const response = r.data
                const { status } = response
                if (status === 200) {
                    // handle data
                    this.tables = response.data.gameTableList
                    this.goodRoadTablesCache = filterGoodRoadGameTables(
                        response.data.gameTableList || []
                    )
                    this.recalculateGoodRoadCount()

                    if (response.data.memberLimitList) {
                        store.commit(
                            UserMutation.SET_USER_INFO_LIMITS,
                            response.data.memberLimitList
                        )
                    }

                    if (response.data.noticeList.length > 0) {
                        // save loby notice
                        let noticeContent = ''
                        response.data.noticeList.forEach((x, index) => {
                            let sufix = ''
                            if (index > 0) sufix = ', '
                            noticeContent += `${sufix}${x.content}`
                        })
                        store.commit(
                            LobyMutation.SET_LOBY_NOTICE,
                            noticeContent
                        )
                    }

                    if (response.data.memberAmount) {
                        store.commit(
                            UserMutation.SET_BET_COIN,
                            response.data.memberAmount
                        )
                    }

                    if (this.selectedTables.length === 0) {
                        const _selectedTables: number[] = []
                        for (
                            let index = 0;
                            index < this.tables.length;
                            index++
                        ) {
                            const element = this.tables[index]
                            if (index === 0) this.currentDeskNo = element.id

                            if (index <= 5) {
                                _selectedTables.push(element.id)
                            }
                        }
                        store.commit(
                            MultiViewMutations.SET_SELECTED_MULTIDESK_TABLES,
                            _selectedTables
                        )
                        // this.loadDeskInfo()
                    } else {
                        if (this.currentDeskNo === -1)
                            this.currentDeskNo = this.tables[0].id
                    }

                    this.loadDeskInfo()
                    if (!this.timerStarted) {
                        this.timerStarted = true
                        this.doCountDown()
                    }
                    // load the current desk Info
                } else if (status === 301) {
                    // session is expired
                    this.endService()
                    this.emitter.emit(EventBuss.SESSION_EXPIRED)
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    this.failureCounter++

                    if (!_forceReload) {
                        this.hideLoading()
                        this.emitter.emit(
                            EventBuss.TOAST_MESSAGE,
                            this.iN('prompt.networkerror')
                        )
                    }
                    if (this.failureCounter > 3) {
                        this.emitter.emit(
                            EventBuss.TOAST_MESSAGE,
                            this.iN('prompt.networkerror')
                        )

                        this.emitter.emit(EventBuss.SOCKET_CLOSE)
                        store.commit(UserMutation.DELETE_SESSION)
                        router.push({ name: ROUTES.LOGIN })
                        return
                    }

                    this.serviceTimeOut = setTimeout(() => {
                        this.loadData(true)
                    }, 3000)
                }
            })
    }

    loadDeskInfo(_forceReload = false): void {
        if (!_forceReload) {
            this.showLoading()
        }

        const _params = {
            memberId: this.memberId,
            tableId: this.currentDeskNo,
            token: this.token,
            limitId: this.limitId
        }

        getTableInfo(_params)
            .then(r => {
                const response = r.data
                if (!_forceReload) this.hideLoading()
                if (response.status === 200) {
                    const tempDesk = response.data.gameTable

                    this.currentDesk = tempDesk
                    this.gType = this.currentDesk.gameTypeNo
                    // console.log('this.currentDesk is change')

                    const gameChips = tempDesk.expand.memberChipsShow
                        .split(',')
                        .map(Number)
                    store.commit(DeskMutation.SET_CHIP_VALUES, gameChips)

                    if (this.chipIndex === -1 && gameChips.length > 0) {
                        this.setCurrentChipIndex(0)
                    }

                    if (response.data.gameTable.expand.amount) {
                        store.commit(
                            UserMutation.SET_BET_COIN,
                            response.data.gameTable.expand.amount
                        )
                    }
                    this.videos = (tempDesk.cmccLine || '').split('$')

                    this.initVideoPlayer()

                    // set personal limit
                    if (this.deskLimit) {
                        const {
                            superSixDownLimit,
                            superSixUpLimit,
                            upLimit,
                            downLimit,
                            limitMax,
                            tieDownLimit,
                            tieUpLimit,
                            pairDownLimit,
                            pairUpLimit,
                            bigTigerUpLimit,
                            smallTigerUpLimit,
                            bigTigerDownLimit,
                            smallTigerDownLimit,
                            dragonSevenDownLimit,
                            dragonSevenUpLimit,
                            bearEightDownLimit,
                            bearEightUpLimit
                        } = tempDesk

                        const _limit: MemberLimit = {
                            upLimit,
                            downLimit,
                            superSixDownLimit,
                            superSixUpLimit,
                            tieDownLimit,
                            tieUpLimit,
                            pairDownLimit,
                            pairUpLimit,
                            id: this.deskLimit.id,
                            bigTigerUpLimit,
                            smallTigerUpLimit,
                            bigTigerDownLimit,
                            smallTigerDownLimit,
                            dragonSevenDownLimit,
                            dragonSevenUpLimit,
                            bearEightDownLimit,
                            bearEightUpLimit
                        }

                        store.commit(DeskMutation.SET_DESK_LIMIT, _limit)
                    }
                } else if (response.status === 301) {
                    this.endService()
                    this.emitter.emit(EventBuss.SESSION_EXPIRED)
                }
            })
            .catch(e => {
                if (!axios.isCancel(e)) {
                    this.failureCounter += 1

                    if (!_forceReload) {
                        this.hideLoading()
                    }

                    if (this.failureCounter > 3) {
                        this.emitter.emit(
                            EventBuss.TOAST_MESSAGE,
                            this.iN('prompt.networkerror')
                        )

                        this.emitter.emit(EventBuss.SOCKET_CLOSE)
                        store.commit(UserMutation.DELETE_SESSION)
                        router.push({ name: ROUTES.LOGIN })

                        return
                    }

                    this.serviceTimeOut = setTimeout(() => {
                        this.loadData(true)
                    }, this.PULL_INTERVAL)
                }
            })
    }

    loadSelectedDesk(_forceReload = false): void {
        let tableIds = this.selectedTables.join(',')
        const _params: any = {
            token: this.token,
            memberId: this.memberId,
            tableIds: tableIds,
            limitId: this.limitId
        }

        if (!_forceReload) {
            this.showLoading()
        }

        getMultiTableDetail(_params)
            .then(r => {
                const response = r.data
                if (!_forceReload) this.hideLoading()
                if (response.status === 200) {
                    this.multipleTables = response.data.gameTableList
                    // console.log('Loaded MUL')
                } else {
                    this.endService()
                    this.emitter.emit(EventBuss.SESSION_EXPIRED)
                }
            })
            .catch(e => {
                if (!axios.isCancel(e)) {
                    this.failureCounter += 1

                    if (!_forceReload) {
                        this.hideLoading()
                    }

                    if (this.failureCounter > 3) {
                        this.emitter.emit(
                            EventBuss.TOAST_MESSAGE,
                            this.iN('prompt.networkerror')
                        )

                        this.emitter.emit(EventBuss.SOCKET_CLOSE)
                        store.commit(UserMutation.DELETE_SESSION)
                        router.push({ name: ROUTES.LOGIN })

                        return
                    }

                    this.serviceTimeOut = setTimeout(() => {
                        this.loadData(true)
                    }, this.PULL_INTERVAL)
                }
            })
    }
    toLoby(): void {
        router.push({ name: ROUTES.LOBY })
    }

    OnShowSwitchTable(): void {
        this.showSwicthTable = !this.showSwicthTable
        if (this.showSwicthTable) this.showGoodRoadPanel = false
    }

    OnShowGoodRoad(): void {
        this.showGoodRoadPanel = !this.showGoodRoadPanel
        if (this.showGoodRoadPanel) this.showSwicthTable = false
    }

    onGoodRoadSync(desksByType: { G002: Table[]; G003: Table[] }): void {
        this.goodRoadTablesCache = [
            ...(desksByType.G002 || []),
            ...(desksByType.G003 || [])
        ]
        this.recalculateGoodRoadCount()
    }

    recalculateGoodRoadCount(): void {
        this.goodRoadCount = countGoodRoadTables(this.goodRoadTablesCache)
    }

    updateGoodRoadCacheTable(table: Table): void {
        if (table.gameTypeNo !== 'G002' && table.gameTypeNo !== 'G003') {
            return
        }

        const index = this.goodRoadTablesCache.findIndex(t => t.id === table.id)
        if (index !== -1) {
            this.goodRoadTablesCache.splice(index, 1, table)
        } else {
            this.goodRoadTablesCache.push(table)
        }

        this.recalculateGoodRoadCount()
    }

    syncGoodRoadCountFromSocket(_type: string, gameTable?: Table): void {
        if (
            _type !== SOCKET_MESSAGE.NEW_GAME &&
            _type !== SOCKET_MESSAGE.END_GAME &&
            _type !== SOCKET_MESSAGE.STOP_GAME &&
            _type !== SOCKET_MESSAGE.NEW_SHOE
        ) {
            return
        }

        if (!gameTable) return

        this.updateGoodRoadCacheTable(gameTable)
    }

    endService(): void {
        if (AxiosSource) {
            AxiosSource.Source.cancel()
            AxiosSource.Source = axios.CancelToken.source()
        }

        if (typeof this.serviceTimeOut === 'number') {
            clearInterval(this.serviceTimeOut)
            this.serviceTimeOut = false
        }
    }

    startCounDownService(): void {
        if (typeof this.countDownTimer !== 'number') {
            this.currentCount = this.currentDesk?.expand.daoJiShiBetTime ?? 0
            this.countDownTimer = setInterval(() => {
                if (this.currentCount < 0) {
                    this.stopCountDown()
                } else {
                    this.currentCount -= 1
                }
            }, 1000)
        }
    }

    stopCountDown(): void {
        if (typeof this.countDownTimer === 'number') {
            clearInterval(this.countDownTimer)
            this.countDownTimer = false
            this.timerStarted = false
        }
    }

    OnCLickToggleFullScreen(): void {
        this.setFullScreen(!this.isFullScreen)
        if (!this.isFullScreen && screenfull.isEnabled) {
            const sc = screenfull as Screenfull
            sc.exit()
        }
    }

    getChipImageWebp(amount: number): string {
        return require(`@/assets/imgs/chips${amount}.webp`)
    }

    getChipImageWebpPng(amount: number): string {
        return require(`@/assets/imgs/chips${amount}.png`)
    }
    getCustomChipValue(): unknown {
        return this.customChipValue <= 0 ? '自定义' : this.customChipValue
    }

    chipClicked(index: number): void {
        if (index === this.chipIndex && this.chipIndex !== -1) {
            this.setCurrentChipIndex(-1)
            // this.chip = 0
            return
        }

        this.setCurrentChipIndex(index)
        // this.chip = amount
    }

    toggleSuper6Mode(isTrue: boolean): void {
        this.isSuper6Mode = isTrue
    }

    showChipDialog(isTrue: boolean): void {
        if (isTrue) {
            this.showCustumChip = true
        } else {
            if (this.customChipValue > 0) {
                if (this.chipIndex === 5) {
                    // this.chip = 0
                    this.setCurrentChipIndex(-1)
                } else {
                    this.setCurrentChipIndex(5)
                    // this.chip = this.customChipValue
                }
            } else {
                this.showCustumChip = true
            }
        }
    }

    OnClickCustumerService(): void {
        window.open(process.env.VUE_APP_CUSTUMER_SERVICE, '_blank')
    }

    OnClickRules(): void {
        // window.open(
        //     'http://kkw6888.com/resource/rules/rule_home.html',
        //     '_blank'
        // )
        this.showRule = true
    }

    onSwitchTable(desk: Table): void {
        this.showSwicthTable = false
        this.enterGameLoby(desk)
        router.push({ name: ROUTES.GAME })
        this.endService()
        // reset betting
    }

    OnSwitchDeskFocus(deskNo: number): void {
        if (this.currentDeskNo !== deskNo) {
            this.currentDeskNo = deskNo
            this.loadDeskInfo()
        }
    }

    //#region Video Player
    async initVideoPlayer(): Promise<void> {
        this.videoIsLoading = true

        if (this.videoAxiosSource) {
            this.videoAxiosSource.cancel()
        }
        this.videoAxiosSource = axios.CancelToken.source()

        const session = ++this.videoPlayerSession

        this.disposeVideoPlayer()

        const cmccLine = (this.currentDesk?.cmccLine || '').split('$')[0]
        if (!cmccLine) return

        let videoPath = ''
        try {
            const parsed = new URL(cmccLine)
            videoPath = parsed.pathname.replace(/^\//, '')
        } catch {
            return
        }
        if (!videoPath) return

        const line: number = store.getters['serverLine']
        let apiBase = ''
        if (line === 1) apiBase = process.env.API_LINE1 || ''
        else if (line === 2) apiBase = process.env.API_LINE2 || ''
        else if (line === 3) apiBase = process.env.API_LINE3 || ''
        else if (line === -1) apiBase = store.getters['serverLineStr'] || ''
        else apiBase = process.env.API_LINE1 || ''
        const phpBase = apiBase.replace(/\/$/, '').replace(/\/\/api/, '//xxapi')

        let signedUrls: string[] = []
        try {
            const { data } = await axios.get<{ urls: string[] }>(
                `${phpBase}/videoxx.php`,
                {
                    params: { safeUrl: 'QWE~!@wwCa99AS', path: videoPath },
                    cancelToken: this.videoAxiosSource.token
                }
            )
            signedUrls = Array.isArray(data.urls) ? data.urls : []
        } catch {
            signedUrls = []
        }

        if (session !== this.videoPlayerSession) return
        if (!signedUrls.length) return

        // 同时向所有线路发起连接，第一路 start → 赢家，立即停掉其余所有连接
        let won = false

        signedUrls.forEach(url => {
            // eslint-disable-next-line no-undef
            const _player = new NodePlayer()
            _player.setVolume(0)
            _player.setView('videoplayer2')
            _player.setBufferTime(1000)
            _player.setScaleMode(2)
            _player.on('start', () => {
                if (session !== this.videoPlayerSession || won) {
                    _player.clearView()
                    _player.stop()
                    return
                }
                won = true
                this.nodePlayer = _player
                this.nodePlayer.clearView()
                this.nodePlayer.setView('videoplayer1')
                this.nodePlayer.on(
                    'buffer',
                    (evt: 'empty' | 'buffering' | 'full') => {
                        if (evt === 'empty' || evt === 'buffering') {
                            this.videoIsLoading = true
                        } else if (evt === 'full') {
                            this.videoIsLoading = false
                        }
                    }
                )
                this.nodePlayer.on('error', () => {
                    this.videoIsLoading = true
                    setTimeout(() => {
                        if (this.nodePlayer) {
                            this.nodePlayer.clearView()
                            this.nodePlayer.stop()
                        }
                        this.initVideoPlayer()
                    }, 1000)
                })
            })
            _player.on('error', () => {
                _player.clearView()
                _player.stop()
            })
            this.videoPlayerCollection.push(_player)
            _player.start(url)
        })
    }

    disposeVideoPlayer(): void {
        if (this.nodePlayer) {
            this.nodePlayer.stop()
            this.nodePlayer.clearView()
            this.nodePlayer = undefined
            this.videoIsLoading = true
        }

        this.videoPlayerCollection.forEach(_player => {
            if (_player) {
                _player.clearView()
                _player.stop()
            }
        })

        this.videoPlayerCollection = []
    }

    //#endregion

    //#region  Drag Events

    handleDragStart(_deskData: Table, e: DragEvent): void {
        const _deskId = _deskData.id
        e.dataTransfer?.setData('id', String(_deskId))
    }

    handleDrop(_deskData: Table, e: DragEvent): void {
        const toId = e.dataTransfer?.getData('id')

        const fromId = this.selectedTables.indexOf(_deskData.id as number)

        this.selectedTables[fromId] = parseInt(toId as string)
        this.activeDragIndex = -1
    }

    handleDragLeave(e: DragEvent): void {
        const id = (e.relatedTarget as HTMLElement).id
        if (id === 'box1' || id === 'box2') {
            this.activeDragIndex = -1
        }
    }

    //#endregion

    @Watch('customChipValue', { immediate: false })
    WatchCustumChipChange(value: number): void {
        if (value > 0) this.setCurrentChipIndex(5)
    }

    @Watch('currentDesk', { immediate: false, deep: true })
    OnCurrentDeskChange(value: Table): void {
        if (value) {
            // console.log('Change Table 11')
            if (value.expand.daoJiShiBetTime > 0) {
                this.startCounDownService()
            } else {
                this.stopCountDown()
            }
        }
    }

    @Watch('selectedTables', { immediate: true, deep: true })
    onSelectedTablesChange(v: number[]) {
        if (v.length > 0) {
            this.loadSelectedDesk()
        }
    }

    get timerColor(): string {
        if (this.currentCount > 20) {
            return 'primary'
        } else if (this.currentCount <= 20 && this.currentCount > 10) {
            return 'warning'
        } else {
            return 'danger'
        }
    }

    get leftListData(): Array<Table> {
        const _listData = new Array<Table>()
        this.selectedTables.forEach((deskNo: number, index: number) => {
            if (index > 2) return _listData
            for (let i = 0; i < this.multipleTables.length; i++) {
                if (deskNo === this.multipleTables[i].id)
                    _listData.push(this.multipleTables[i])
            }
        })
        return _listData
    }

    get rightListData(): Array<Table> {
        const _listData = new Array<Table>()

        this.selectedTables.forEach((deskNo: number, index: number) => {
            if (index > 2) {
                for (let i = 0; i < this.multipleTables.length; i++) {
                    if (deskNo === this.multipleTables[i].id)
                        _listData.push(this.multipleTables[i])
                }
            }
        })

        return _listData
    }

    get centerListData(): Array<Table> {
        const _listData = new Array<Table>()
        this.tables.forEach((desk: Table) => {
            let isListed = false
            for (let index = 0; index < this.selectedTables.length; index++) {
                const tableNo = this.selectedTables[index]
                if (tableNo === desk.id) {
                    isListed = true
                    // break
                }
            }
            if (!isListed) _listData.push(desk)
        })

        return _listData
    }

    get chip(): number {
        if (this.chipIndex === 5) return this.customChipValue

        if (this.chipIndex === -1) return 0

        const amt = this.chips[this.chipIndex]
        if (amt) return amt
        return 0
    }

    get title(): string {
        let currentDeskData: Table | undefined = undefined

        for (let i = 0; i < this.tables.length; i++) {
            const desk = this.tables[i]
            if (desk.id === this.currentDeskNo) {
                currentDeskData = desk
                break
            }
        }

        if (!currentDeskData) return ''

        const { gameTypeNo, id } = currentDeskData as Table

        if (gameTypeNo === 'G002') {
            return `百家乐 ${id} 号桌`
        } else {
            return `龙虎 ${id} 号桌`
        }
    }
}
